/**
 * 会中门户会议生命周期：结束全员写 ENDED、普通离开、回主页。
 */
import { clearActiveMeetingId, getAccessToken, getActiveMeetingId } from './authStorage';
import { getPortalApiBaseUrl } from './config';
import logger from './logger';
/** 主持人已发出全员结束：离会中间件不再走 /leave 或 occupancy=0。 */
let hostEndedForAll = false;
/**
 * 当前会是否已由主持人点「结束会议」发出 /end。
 *
 * @returns {boolean}
 */
export function isHostEndedForAll() {
    return hostEndedForAll;
}
/**
 * 新入会时清掉上一场的全员结束标记。
 *
 * @returns {void}
 */
export function resetHostEndedForAll() {
    hostEndedForAll = false;
}
/**
 * 页面卸载后仍能送达的门户 POST（避免 location.replace / 关窗取消普通 fetch）。
 *
 * @param {string} path - 如 /api/meetings/1/end
 * @param {string} accessToken - 门户 token
 * @param {string} logLabel - 中文日志标签
 * @returns {void}
 */
function postPortalKeepalive(path, accessToken, logLabel) {
    const url = `${getPortalApiBaseUrl()}${path}`;
    const now = new Date().toISOString();
    try {
        fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            keepalive: true,
            body: '{}'
        }).then(response => {
            if (response.ok || response.status === 204) {
                logger.info(`[${now}] ${logLabel}已接受 | path=${path} status=${response.status}`);
            }
            else {
                logger.warn(`[${now}] ${logLabel}失败 | path=${path} status=${response.status}`);
            }
        }).catch((error) => {
            logger.warn(`[${now}] ${logLabel}异常 | path=${path} error=${error?.message || error}`);
        });
    }
    catch (error) {
        logger.warn(`[${now}] ${logLabel}抛出 | path=${path} error=${error?.message || error}`);
    }
}
/**
 * 主持人结束全体会议：立即通知门户将 DB status 标为 ENDED。
 * 使用 keepalive，发出后即可跳转/关窗，不阻塞 UI。
 *
 * @returns {boolean} 是否已发出门户结束请求
 */
export function markPortalMeetingEndedNow() {
    const token = getAccessToken();
    const meetingId = getActiveMeetingId();
    const now = new Date().toISOString();
    if (!token || !meetingId) {
        logger.warn(`[${now}] 跳过门户结束会议（缺少 token/meetingId） | hasToken=${Boolean(token)} meetingId=${meetingId}`);
        return false;
    }
    hostEndedForAll = true;
    logger.info(`[${now}] 主持人结束会议，立即通知门户写 ENDED | meetingId=${meetingId}`);
    postPortalKeepalive(`/api/meetings/${meetingId}/end`, token, '门户结束会议');
    clearActiveMeetingId();
    return true;
}
/**
 * 普通离开会议：通知门户 leave（不标全员 ENDED）。
 *
 * @returns {boolean} 是否已发出离会请求
 */
export function markPortalMeetingLeftNow() {
    const token = getAccessToken();
    const meetingId = getActiveMeetingId();
    const now = new Date().toISOString();
    if (!token || !meetingId || hostEndedForAll) {
        return false;
    }
    logger.info(`[${now}] 普通离会，通知门户 leave | meetingId=${meetingId}`);
    postPortalKeepalive(`/api/meetings/${meetingId}/leave`, token, '门户离会');
    clearActiveMeetingId();
    return true;
}
/**
 * Web 非嵌入场景：立刻回到门户主页（触发 PortalApp 刷新列表）。
 *
 * @returns {void}
 */
export function redirectToPortalHomeNow() {
    logger.info(`[${new Date().toISOString()}] 结束/离开会议，立刻返回门户主页`);
    window.location.replace('/');
}
